import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const DEFAULT_TIMEZONE = 'Australia/Melbourne';

const FALLBACK_CUSTOMER_LIMIT = 5000;

// "11:59pm Wednesday 19th August" — the form used in the T&Cs.
export function formatOfferDateTime(date, tz = DEFAULT_TIMEZONE) {
  if (!date) return '';
  return dayjs(date).tz(tz).format('h:mma dddd Do MMMM');
}

// "11:59pm 19/08/2026" — the form used in the footnote under each screen.
export function formatShortDateTime(date, tz = DEFAULT_TIMEZONE) {
  if (!date) return '';
  return dayjs(date).tz(tz).format('h:mma DD/MM/YYYY');
}

export function offerFootnote(offer) {
  const { endDate, timezone: tz, totalCodeCount } = offer || {};
  const expiry = formatShortDateTime(endDate, tz);
  const customerLimit = totalCodeCount ?? FALLBACK_CUSTOMER_LIMIT;
  return (
    `*Only Valid once added to MyMacca’s® account. ` +
    `Limited to first ${customerLimit.toLocaleString('en-AU')} customers.` +
    `${expiry ? ` Codes will be valid until ${expiry}.` : ''}`
  );
}
